import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-btn-call-to-action',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './btn-call-to-action.component.html',
  styleUrl: './btn-call-to-action.component.css',
})
export class BtnCallToActionComponent {
  @Input() btnText: string = '';
  @Input() isLoading$: Observable<boolean> = new Observable();

  constructor() {}
}
